import { getSearchParamsString } from '@reapitform/utils'
import { getUrl, usePlatformGet } from '@reapitform/hooks'
import { IDocumentDefault, IPaginationParams, IResponseWithPagination } from '../../types'
import React from 'react'
import { useQueryClient } from '@tanstack/react-query'

export const useDefaultsDocument = (params: IPaginationParams) => {
  const queryClient = useQueryClient()

  const searchParams = getSearchParamsString(params)
  const path: string = `/api/Organization/DefaultAttachment${searchParams}`
  const [result, loading, errorString] = usePlatformGet<IResponseWithPagination<IDocumentDefault>>({
    path,
    retry: false,
  })

  const queryKey = React.useMemo(getUrl(path), [path])

  const { _embedded, ...pagination } = result ?? {}

  const updateCacheData = (data: IDocumentDefault[] | ((preData: IDocumentDefault[]) => IDocumentDefault[])) => {
    if (!queryClient) return

    queryClient.setQueryData([queryKey], (prevData: IResponseWithPagination<IDocumentDefault>) => {
      let newValue = data
      if (typeof data === 'function') newValue = data(prevData._embedded)

      return { ...prevData, _embedded: newValue }
    })

    queryClient.invalidateQueries({ queryKey: [queryKey] })
  }

  return { data: _embedded, pagination: pagination, loading, errorString, updateCacheData }
}
